import axios from 'axios';

const customTextApi = axios.create({
  baseURL: `/course-evaluations/student`,
});

export const getCourseCustomText = async (brandId, courseId) => {
  const params = { brandId: brandId };
  const { data } = await customTextApi.get(`/course/${courseId}/custom-text`, { params });
  return data;
}

export const getTeacherCustomText = async (brandId, teacherId, courseId) => {
  const params = { brandId: brandId };
  const { data } = await customTextApi.get(`/teacher/${teacherId}/course/${courseId}/custom-text`, { params });
  return data;
}